// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contMainModal {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
}   
.compactMainModal{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 95%;
    height: 95%;
   
}
.titleMainModal, .footerMainModal {
    width: 100%;
    height: 10%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5em;
    font-weight: bold;
     
}
.titleMainModal{
    border-bottom: 1px solid rgba(209, 209, 209, 0.842);
}
.footerMainModal{
    border-top: 1px solid rgba(209, 209, 209, 0.842);
}
.bodyMainModal {
    width: 100%;
    height: 80%;
    display: flex;
    align-items: center;
    justify-content: center;

}
.txtTitleMainModal{
    color:var(--third-color);
   
}

/* Styles for body*/
.compactBodyMainModal  {
   width: 100%;
  height: 100%;
  position: relative;
  display: flex;
    flex-direction: column;
}
.headBodyMainModal {
    position: relative;
  display: flex;
  width: 100%;
  height: 10%;
  justify-content: center;
  align-items: center;
}
.menuOptionsModal {
   position: relative;
  display: flex;
  justify-content: left;
  align-items: center;
  width: 100%;
  height: 70%;
}
.compactMenuOptionsModal{
    position: relative;
  display: flex;
  width: 90%;
  height: 100%;
  left: 5%;
  align-items: center;
  list-style-type: none;
  padding: 0;
  margin: 0;
  overflow: auto;
  justify-content: start;
   top: 20%;
}
.compactMenuOptionsModal li {
  flex-grow: 1;
  min-width: 120px;
  width: auto;
  height: 80%;
  margin-right: 5px;
  margin-left: 5px;
  background-color: transparent;
  border-right: 1px solid #a1a1a150;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--font-size-xSmall);
  cursor: pointer;
  color: rgba(195,195,195,1);
  color: var(--third-color);
  text-align: center;
 
}
.step-selected {
    border-radius: 10px 10px 0px 0px;
  background-color: rgba(195,195,195,1) !important;
  background-color: #003757 !important;
  color: rgb(1, 17, 31) !important;
  color: aliceblue !important;
}

/* Styles for step1*/

.cont-step-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
}
.compact-step-modal{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 95%;
    height: 95%;
}
.title-step-modal {
    width: 100%;
    height: 10%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2em;
    font-weight: bold;
    color: var(--third-color);
    border-bottom: 1px solid rgba(209, 209, 209, 0.842);
}
.body-step-modal {
    width: 100%;
    height: 90%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}   
.compact-body-step-modal{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    overflow: auto;
}   
.row-form-modal,.row-form-modal-dobel{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 20%; 
}
.row-form-modal-dobel{
    height: 40%; 
}
.colum-form-modal{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 45%;
    height: 80%; 
    margin-left: 5px;
    margin-right: 5px;
}

/* footer */
.compactFooterMainModal{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 95%;
    height: 95%;
}
.glosario-footer-modal{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 25%;
    height: 100%;
    font-size: var(--font-size-xSmall);
    color: var(--txt-color);
    font-weight: normal;
}
.actions-footer-modal{      
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    width: 75%;
    height: 100%;

}
.separador-footer-modal{
    width: 20%  ;   
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px;
    
}
.load-data-selector{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    color: var(--txt-color);
}   
.disabled-step{
    pointer-events: none;
    opacity: 0.6;
   
}`, "",{"version":3,"sources":["webpack://./src/components/cis-components/ModalCreate/styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,WAAW;;AAEf;AACA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;;AAErB;AACA;IACI,mDAAmD;AACvD;AACA;IACI,gDAAgD;AACpD;AACA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;AAE3B;AACA;IACI,wBAAwB;;AAE5B;;AAEA,mBAAmB;AACnB;GACG,WAAW;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;IACX,sBAAsB;AAC1B;AACA;IACI,kBAAkB;EACpB,aAAa;EACb,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,mBAAmB;AACrB;AACA;GACG,kBAAkB;EACnB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;AACA;IACI,kBAAkB;EACpB,aAAa;EACb,UAAU;EACV,YAAY;EACZ,QAAQ;EACR,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,cAAc;EACd,sBAAsB;GACrB,QAAQ;AACX;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;;AAEpB;AACA;IACI,gCAAgC;EAClC,gDAAgD;EAChD,oCAAoC;EACpC,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA,oBAAoB;;AAEpB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,WAAW;AACf;AACA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,mDAAmD;AACvD;AACA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,UAAU;IACV,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,UAAU;IACV,YAAY;IACZ,kCAAkC;IAClC,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,UAAU;IACV,YAAY;;AAEhB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;;AAEhB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,uBAAuB;AAC3B;AACA;IACI,oBAAoB;IACpB,YAAY;;AAEhB","sourcesContent":[".contMainModal {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 100%;\r\n    height: 100%;\r\n}   \r\n.compactMainModal{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 95%;\r\n    height: 95%;\r\n   \r\n}\r\n.titleMainModal, .footerMainModal {\r\n    width: 100%;\r\n    height: 10%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 1.5em;\r\n    font-weight: bold;\r\n     \r\n}\r\n.titleMainModal{\r\n    border-bottom: 1px solid rgba(209, 209, 209, 0.842);\r\n}\r\n.footerMainModal{\r\n    border-top: 1px solid rgba(209, 209, 209, 0.842);\r\n}\r\n.bodyMainModal {\r\n    width: 100%;\r\n    height: 80%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n}\r\n.txtTitleMainModal{\r\n    color:var(--third-color);\r\n   \r\n}\r\n\r\n/* Styles for body*/\r\n.compactBodyMainModal  {\r\n   width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  display: flex;\r\n    flex-direction: column;\r\n}\r\n.headBodyMainModal {\r\n    position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  height: 10%;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.menuOptionsModal {\r\n   position: relative;\r\n  display: flex;\r\n  justify-content: left;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 70%;\r\n}\r\n.compactMenuOptionsModal{\r\n    position: relative;\r\n  display: flex;\r\n  width: 90%;\r\n  height: 100%;\r\n  left: 5%;\r\n  align-items: center;\r\n  list-style-type: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  overflow: auto;\r\n  justify-content: start;\r\n   top: 20%;\r\n}\r\n.compactMenuOptionsModal li {\r\n  flex-grow: 1;\r\n  min-width: 120px;\r\n  width: auto;\r\n  height: 80%;\r\n  margin-right: 5px;\r\n  margin-left: 5px;\r\n  background-color: transparent;\r\n  border-right: 1px solid #a1a1a150;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: var(--font-size-xSmall);\r\n  cursor: pointer;\r\n  color: rgba(195,195,195,1);\r\n  color: var(--third-color);\r\n  text-align: center;\r\n \r\n}\r\n.step-selected {\r\n    border-radius: 10px 10px 0px 0px;\r\n  background-color: rgba(195,195,195,1) !important;\r\n  background-color: #003757 !important;\r\n  color: rgb(1, 17, 31) !important;\r\n  color: aliceblue !important;\r\n}\r\n\r\n/* Styles for step1*/\r\n\r\n.cont-step-modal {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n.compact-step-modal{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 95%;\r\n    height: 95%;\r\n}\r\n.title-step-modal {\r\n    width: 100%;\r\n    height: 10%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 1.2em;\r\n    font-weight: bold;\r\n    color: var(--third-color);\r\n    border-bottom: 1px solid rgba(209, 209, 209, 0.842);\r\n}\r\n.body-step-modal {\r\n    width: 100%;\r\n    height: 90%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n}   \r\n.compact-body-step-modal{\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    overflow: auto;\r\n}   \r\n.row-form-modal,.row-form-modal-dobel{\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 100%;\r\n    height: 20%; \r\n}\r\n.row-form-modal-dobel{\r\n    height: 40%; \r\n}\r\n.colum-form-modal{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    justify-content: center;\r\n    width: 45%;\r\n    height: 80%; \r\n    margin-left: 5px;\r\n    margin-right: 5px;\r\n}\r\n\r\n/* footer */\r\n.compactFooterMainModal{\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    width: 95%;\r\n    height: 95%;\r\n}\r\n.glosario-footer-modal{\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    width: 25%;\r\n    height: 100%;\r\n    font-size: var(--font-size-xSmall);\r\n    color: var(--txt-color);\r\n    font-weight: normal;\r\n}\r\n.actions-footer-modal{      \r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n    width: 75%;\r\n    height: 100%;\r\n\r\n}\r\n.separador-footer-modal{\r\n    width: 20%  ;   \r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin: 10px;\r\n    \r\n}\r\n.load-data-selector{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 100%;\r\n    width: 100%;\r\n    color: var(--txt-color);\r\n}   \r\n.disabled-step{\r\n    pointer-events: none;\r\n    opacity: 0.6;\r\n   \r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
